/**
 * Value used when default TTS override text should be used instead of text specific to a single voice.
 *
 * @note This is not an actual voice code, so it should never be set on a design language, but will be used as the default override text & for TTS audio.
 */
export const defaultTtsVoice = 'default';
